import { render, staticRenderFns } from "./deng.vue?vue&type=template&id=b8ad7c8a"
import script from "./deng.vue?vue&type=script&lang=js"
export * from "./deng.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports